const GuamSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111531)">
      <path
        d="M8.72803 36.5223C11.9377 38.7165 15.819 40.0006 20.0004 40.0006C24.1819 40.0006 28.0631 38.7165 31.2729 36.5223L20.0004 34.7832L8.72803 36.5223Z"
        fill="#D80027"
      />
      <path
        d="M31.2729 3.47828C28.0631 1.28414 24.1819 0 20.0004 0C15.819 0 11.9377 1.28414 8.72803 3.47828L20.0004 5.21742L31.2729 3.47828Z"
        fill="#D80027"
      />
      <path
        d="M40 20.0002C40 13.3823 36.0378 6.73617 31.2724 3.47852H8.72758C3.45859 7.08039 0 13.1362 0 20.0002C0 26.8645 3.45859 32.9201 8.72758 36.522H31.2724C36.5415 32.9201 40 26.8645 40 20.0002Z"
        fill="#0052B4"
      />
      <path
        d="M18.8686 32.624C18.5953 32.3896 12.1743 26.8077 12.1743 19.9992C12.1743 13.1907 18.5953 7.60875 18.8686 7.37445L20.0004 6.4043L21.1322 7.37437C21.4055 7.60875 27.8265 13.1906 27.8265 19.9992C27.8265 26.8078 21.4056 32.3898 21.1322 32.624L20.0004 33.5941L18.8686 32.624Z"
        fill="#D80027"
      />
      <path
        d="M26.0875 19.9997C26.0875 13.9127 20.0005 8.69531 20.0005 8.69531C20.0005 8.69531 13.9136 13.9129 13.9136 19.9997C13.9136 21.8618 14.4837 23.6422 15.2744 25.2171H24.7266C25.5174 23.6422 26.0875 21.8618 26.0875 19.9997Z"
        fill="#338AF3"
      />
      <path
        d="M26.0875 20C26.0875 21.8621 25.5174 23.6425 24.7266 25.2174L20.0005 26.087L15.2744 25.2174C14.4837 23.6426 13.9136 21.8621 13.9136 20H26.0875Z"
        fill="#0052B4"
      />
      <path
        d="M20.0005 31.3038C20.0005 31.3038 22.9324 28.7899 24.7266 25.2168H15.2744C17.0686 28.7899 20.0005 31.3038 20.0005 31.3038Z"
        fill="#FFDA44"
      />
      <path d="M16.0864 16.5215H23.9125L19.9995 20.4345L16.0864 16.5215Z" fill="#6DA544" />
      <path d="M18.6958 19.1299H21.3045V26.956H18.6958V19.1299Z" fill="#A2001D" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111531">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GuamSvg;
